export enum DATA_QA {
  ROOT = 'date-time',
  DATE_INPUT = 'date-time__date-input',
  TIME_INPUT = 'date-time__time-input',
}
